import {UseQueryOptions, UseQueryResult, useQuery} from '@tanstack/react-query';
import {IPresentationTheme} from '../incase-domain/presentationTheme';
import {fetchPresentationThemeService} from '../service/presentationTheme.service';
import {QUERY_KEYS} from '../utils/queryKeys';

type PresentationThemeDetailQueryKey = ReturnType<typeof QUERY_KEYS.theme.detail>;

export function usePresentationThemeDetailQuery(
    themeId: string | null | undefined,
    options?: Omit<UseQueryOptions<IPresentationTheme, Error, IPresentationTheme, PresentationThemeDetailQueryKey>, 'queryKey' | 'queryFn'>
): UseQueryResult<IPresentationTheme, Error> {
    const id = themeId ?? '';
    return useQuery(QUERY_KEYS.theme.detail(id), () => fetchPresentationThemeService(id), {
        enabled: !!themeId,
        ...options,
    });
}
